import { useEffect, useState } from 'react'
import { isLedgerDappBrowserProvider } from 'lib/helpers'
import { LedgerHQFrameConnector } from './connector'
import constate from 'constate'
import { provider } from 'web3-core'

type LedgerType = {
  address: string
  provider: provider
}

const useLedgerProvider = () => {
  const [isLedger, setIsLedger] = useState(isLedgerDappBrowserProvider())
  const [ledger, setLedger] = useState<LedgerType>()
  const [account, setAccount] = useState<string>('')

  const setLedgerProvider = async (LedgerHQFrame: LedgerHQFrameConnector) => {
    const LedgerHQInstance = LedgerHQFrame && (await LedgerHQFrame.activate())
    setLedger({
      address: LedgerHQInstance.account || '',
      provider: LedgerHQInstance.provider,
    })
    if (LedgerHQInstance.provider) {
      LedgerHQInstance.provider.on('accountsChanged', function (accounts: string[]) {
        setAccount(accounts[0])
      })
    }
  }

  useEffect(() => {
    if (isLedger) {
      const LedgerHQFrame = new LedgerHQFrameConnector()
      setLedgerProvider(LedgerHQFrame)
    }
  }, [isLedger])

  return {
    ledger,
    setLedger,
    isLedger,
    setIsLedger,
    account,
  }
}

const [LedgerProvider, useLedgerContext] = constate(useLedgerProvider)

export { LedgerProvider, useLedgerContext }
